import { Dispatch, SetStateAction } from 'react';
import { Modal } from '../Modal/Modal';
import {
  ButtonContainer,
  Title,
  TitleContainer,
  TopContainer,
  Margin,
  ContentContainer,
} from './ExistingCartModal.styled';

import Button from 'components/Button/Button';
import { useTranslation } from 'react-i18next';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';
import { Level } from '../Modal/type';
import { Description } from '../ConfirmModal/ConfirmModal.styled';

interface IExistingCartProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onContinueWithExistingCart: () => void;
  onCreateNewCart: () => void;
  level?: Level;
}

export const ExistingCartModal = ({
  isOpen,
  setIsOpen,
  onContinueWithExistingCart,
  onCreateNewCart,
  level = 'FIRST',
}: IExistingCartProps) => {
  const { t } = useTranslation();
  const { isPhone, isSmallPhone } = useBreakpointFlag();
  return (
    <Modal
      isOpen={isOpen}
      level={level}
      onClose={() => {
        onContinueWithExistingCart();
        setIsOpen(false);
      }}
      modalStyle={{
        position: 'fixed',
        margin: 'auto',
        width: isSmallPhone ? '90%' : '600rem',
        minWidth: isSmallPhone ? '90%' : 'auto',
      }}
    >
      <ContentContainer>
        <TopContainer>
          <TitleContainer>
            <Title>{t('Cart already exists')}</Title>
          </TitleContainer>
          <TitleContainer>
            <Description>
              {t(
                'Do you want to continue with existing cart or create a new one?'
              )}
            </Description>
          </TitleContainer>
        </TopContainer>
        <ButtonContainer>
          <Margin>
            <Button
              onClick={onContinueWithExistingCart}
              secondary
              width={isPhone ? '100rem' : '200rem'}
              label={t('Check cart overview')}
            />
          </Margin>
          <Button
            primary
            width={isPhone ? '100rem' : '200rem'}
            label={t('Create new cart')}
            onClick={onCreateNewCart}
          />
        </ButtonContainer>
      </ContentContainer>
    </Modal>
  );
};
